import OrderDiscounts from '@screens/order/discounts'

export default function OrderDiscountsPage() {
  return <OrderDiscounts />
}
